import { classNames } from '../utilities';

export const CalendarClockIcon = ({ className, onClick }) => {
  return (
    <svg
      id="calender_clock_icon"
      className={classNames('', className ? className : '')}
      onClick={onClick ? onClick : () => null}
      xmlns="http://www.w3.org/2000/svg"
      height="22"
      viewBox="0 -960 960 960"
      width="22"
      fill="#807E7E"
    >
      <path d="M185.385-600.382h589.23v-136.539q0-4.616-3.846-8.463-3.847-3.846-8.463-3.846H197.694q-4.616 0-8.463 3.846-3.846 3.847-3.846 8.463v136.539Zm0 0V-749.23-600.382Zm12.309 500.381q-23.529 0-40.611-17.082-17.082-17.082-17.082-40.611v-579.227q0-23.529 17.082-40.611 17.082-17.082 40.611-17.082h73.846v-70h50.384v70h317.691v-70h49.229v70h73.462q23.529 0 40.611 17.082 17.082 17.082 17.082 40.611v276.997q-10.708-4.977-22.162-8.104-11.453-3.126-23.222-5.357v-81.614h-589.23v397.305q0 4.616 3.846 8.463 3.847 3.846 8.463 3.846h308.999q4.461 12.769 10.538 23.807 6.077 11.038 13.615 21.577H197.694Zm538.114 40q-71.704 0-121.793-50.09-50.09-50.09-50.09-121.794t50.108-121.793q50.108-50.09 121.583-50.09 71.896 0 121.986 50.108 50.089 50.108 50.089 121.583 0 71.896-50.089 121.986-50.09 50.09-121.794 50.09Zm60.265-76.077L820.846-161 747-234.846v-110.462h-34.769V-222l83.842 85.922Z" />
    </svg>
  );
};
